import * as Darby from './darby_alerts';

/*** Product ***/
(function() {
  // Variables
  // =========
  let initialized = false;
  let $categoryResults = $('#category_results');

  // Methods
  // =======
  function init(){
    if (!initialized){
      initialized = true;
      getProducts();
    }
  }

  function toggleCategory() {
    let $categoryButton = $(this);
    $('#category_list button.button').attr('class', 'button badge-pill badge-primary');
    $categoryButton.attr('class', 'button badge-pill badge-success');
    getProducts();
  }

  function collapseAll(){
    $('.collapse').collapse('hide');
  }

  function showModal(){
    const $selectedButton = $(this);
    const $options_modal = $selectedButton.next()
    Darby.showModal($options_modal);
  }

  function getProducts(){
    let page = 1;
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    let categoryIds = $('#category_list button.badge-success').map(function(){
      return $(this).val();
    }).get();
    let productCard = $categoryResults.attr('data-product-card');
    $.ajax(
      {
        /* the route pointing to the post function */
        url: '/products/category_products',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          category_ids: categoryIds,
          card: productCard,
          page: page,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          //console.log(jqXHR);
          $categoryResults.html(data.html);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(textStatus);
          console.log(errorThrown);
          // console.log(jqXHR);
        }
      }
    );
  }

  function toggleModifier() {
    let $selectedModifierButton = $(this);
    let $modifier = $selectedModifierButton.parent();
    let $modifierButtons = $modifier.children('button');
    if ($selectedModifierButton.attr('class') === 'button badge-pill badge-secondary modifier-product') {
      if (parseInt($modifier.attr('data-max')) === 1) {
        $modifierButtons.attr('class', 'button badge-pill badge-secondary modifier-product');
      }
      if ($modifierButtons.filter('.badge-success').length < parseInt($modifier.attr('data-max'))) {
        $selectedModifierButton.attr('class', 'button badge-pill badge-success modifier-product');
      } else {
        Darby.alertModal($modifier.attr('data-max') + ' Max for this modifier. Look at other modifiers for more options.');
      }
    } else if ($modifierButtons.filter('.badge-success').length > parseInt($modifier.attr('data-min'))) {
      $selectedModifierButton.attr('class', 'button badge-pill badge-secondary modifier-product');
    }
  }

  function getModifiers($productButton) {
    let data = {
      message: "",
      modifiers: [],
    };
    let $modifierGroups = $('#modifiers' + $productButton.attr('data-product_id')).find('div.btn-group-toggle');
    $modifierGroups.each(function () {
      let modifier = {
        modifier_id: $(this).attr('data-modifier'),
        selected: [],
      }
      let $selectedButtons = $(this).children('button.badge-success');
      if ($selectedButtons.length < parseInt($(this).attr('data-min'))) {
        data.message += 'Need to select at least ' + $(this).attr('data-min') + ' from ' + $(this).attr('data-title') + '\n';
      }
      $selectedButtons.each(function () {
        modifier.selected.push($(this).attr('data-product'));
        let $customValues = $(this).next('input.custom_amount');
        $customValues.each(function () {
          if ($(this).val() <= 0){
            data.message += 'Invalid Custom Value. \n';
          } else {
            modifier.selected.push($(this).attr('id') + ' ' + $(this).val());
          }
        })
      })
      data.modifiers.push(modifier);
    });
    if (data.message !== '') {
      Darby.alertModal(data.message);
    }
    return data;
  }

  function addToOrder() {
    const $productButton = $(this);
    let modifierObject = getModifiers($productButton);
    if (modifierObject.message === '') {
      let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
      let productId = $productButton.attr("data-product_id");
      let quantity = $('#quantity' + productId).val();
      $('#quantity' + productId).val('1');
      let notes = $('#notes' + productId).val();
      $('#notes' + productId).val('');
      $.ajax(
        {
          /* the route pointing to the post function */
          url: '/orders/add',
          type: 'POST',
          /* send the csrf-token and the input to the controller */
          data: {
            _token: CSRF_TOKEN,
            product_id: productId,
            quantity: quantity,
            notes: notes,
            modifiers: modifierObject.modifiers,
            requestUri: '/orders/add',
          },
          dataType: 'json',
          /* remind that 'data' is the response of the AjaxController */
          success: function (data, textStatus, jqXHR) {
            //console.log(jqXHR);
            if (data.status == 'error'){
              Darby.alertModal(data.message);
            } else {
              $('#order').html(data.order_html);
              $('#order_options').html(data.order_options_html);
              $('.cart').replaceWith(data.order_cart);
              $('.collapse').collapse('hide');
              if (data.redirect){
                window.location.replace(data.redirect);
              }
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            Darby.alertModal('Oops! An error occured');
            window.location.href = "/login";
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      );
    }
  }

  function sendReceipt() {
    let $receiptButton = $(this);
    let modifierObject = getModifiers($receiptButton);
    if (modifierObject.message === '') {
      let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
      let orderId = $receiptButton.attr('data-order_id');
      let message = $('#message' + orderId).val();
      $('#message' + orderId).val('');
      $.ajax(
        {
          /* the route pointing to the post function */
          url: '/orders/send_receipt_modal',
          type: 'POST',
          /* send the csrf-token and the input to the controller */
          data: {
            _token: CSRF_TOKEN,
            order_id: orderId,
            message: message,
            modifiers: modifierObject.modifiers,
            requestUri: '/orders/send_receipt_modal',
          },
          dataType: 'json',
          /* remind that 'data' is the response of the AjaxController */
          success: function (data, textStatus, jqXHR) {
            //console.log(jqXHR);
            if (data.status == 'error'){
              Darby.alertModal(data.message);
            } else {
              // Darby.alertModal(data.message);
              $('.collapse').collapse('hide');
              if (data.redirect){
                window.location.replace(data.redirect);
              }
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            Darby.alertModal(textStatus);
            window.location.href = "/login";
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      );
      /*
      if(document.getElementsByTagName('main')[0].id == "gen2"){
        // normalModal();
      } else {return}

       */
    }

  }

  function deleteFromOrder() {
    let deleteProduct = $(this).attr('data-product_id');
    // console.log(deleteProduct);
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax(
      {
        /* the route pointing to the post function */
        url: '/orderProducts/itemDelete',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          orderProduct_id: deleteProduct,
          quantity: 1,
          // modifiers: modifierObject.modifiers,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function (data, textStatus, jqXHR) {
          //console.log(jqXHR);
          if (data.status == 'error'){
            Darby.alertModal(data.message);
          } else {
            $('#order').html(data.order_html);
            $('#order_options').html(data.order_options_html);
            $('.cart').replaceWith(data.order_cart);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          window.location.href = "/login";
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    ); // END AJAX
  }

  // Events
  // ======

  // Buttons are not on the screen when the page is loaded
  // so need to attach the event to something that is there when loaded.

  // Product Categories in the Store
  const $categoryList = $('#category_list');
  $categoryList.on('click', 'button', toggleCategory);
  // Product Results of toggling Category
  // $categoryResults.on('click', 'button.pos-product', collapseAll);
  // $categoryResults.on('click', 'button.order-product', collapseAll);
  $categoryResults.on('click', 'button.pos-product', showModal);
  $categoryResults.on('click', 'button.order-product', showModal);
  $categoryResults.on('click', 'button.add-to-order', addToOrder);
  $categoryResults.on('click', 'button.modifier-product', toggleModifier);
  // For Product buttons on the page when loaded outside category_results
  const $orderOptions = $('#order_options');
  $('button.pos-product').on('click', showModal);
  $('button.order-product').on('click', showModal);
  $('button.add-to-order').on('click', addToOrder);
  $('button.modifier-product').on('click', toggleModifier); // In Products and Receipt Modals
  // Other order options
  $orderOptions.on('click', 'button.receipt-options', showModal);
  $('button.receipt-options').on('click', showModal);
  $orderOptions.on('click', 'button.send-receipt', sendReceipt);
  $('button.send-receipt').on('click', sendReceipt); // In receipt modal
  $('#order').on('click', '.del-from-order', deleteFromOrder);

  if ( $categoryList.length ) {
    init();
  }

})();


/*** Score links: tickets table and Round Scores (products/{id}, products/{id}/scores) ***/
(function() {
  const $modal = $('#scoreModal');
  if (!$modal.length) return;
  const $input = $modal.find('.js-score-input');
  const $preview = $modal.find('.js-score-preview');
  const $error = $modal.find('.js-score-error');
  const $send = $modal.find('.js-score-send');
  const $cancel = $modal.find('.js-score-cancel');
  const $entry = $modal.find('.js-score-entry');
  const $conflict = $modal.find('.js-score-conflict');
  const $done = $modal.find('.js-score-done');
  const $keep = $modal.find('.js-score-keep');
  const $override = $modal.find('.js-score-override');
  const $close = $modal.find('.js-score-close');
  const HINT = "Their score, then the other team's — e.g. 5 3";
  // What the open modal is scoring: { url, entityId, prefix }
  let target = null;

  /**
   * The command for scores entered against a round ("R2") or a golf spot ("H3"), the same
   * as the app's scoreCommandFor: "5 3" becomes "R2 5 3"; input that already names a round
   * or spot, and "D" / "dinner", go as typed. Null when there is nothing to send.
   */
  function scoreCommandFor(prefix, input) {
    const scores = (input || '').trim().replace(/\s+/g, ' ');
    if (!scores) return null;
    if (/^(d|dinner)$/i.test(scores)) return scores;
    if (/^[a-z]+\d+\b/i.test(scores)) return scores;
    return prefix + ' ' + scores;
  }

  function openModal(data) {
    target = { url: data.url, entityId: data.entityId, prefix: data.prefix };
    $modal.find('.modal-title').text(data.name ? 'Score — ' + data.name : 'Score');
    $modal.find('.js-score-label').text(data.label || '');
    $input.val('');
    $preview.text(HINT);
    $error.text('');
    showEntry();
    $send.prop('disabled', true);
    $modal.modal('show');
  }

  /** Entering scores: the input with Cancel and Send. */
  function showEntry() {
    $entry.removeClass('d-none');
    $conflict.addClass('d-none').text('');
    $done.addClass('d-none').text('');
    $cancel.add($send).removeClass('d-none');
    $keep.add($override).add($close).addClass('d-none');
  }

  /** The scores didn't match the recorded ones: why, with Cancel (keeps them) and Override. */
  function showConflict(text) {
    $conflict.text(text).removeClass('d-none');
    $cancel.add($send).addClass('d-none');
    $keep.add($override).removeClass('d-none').prop('disabled', false);
  }

  /** The token, whose score it is, and the ?user=&code= sign in the scores page came with. */
  function requestData(extra) {
    const data = Object.assign({ _token: $('meta[name="csrf-token"]').attr('content'), entity_id: target.entityId }, extra);
    // The scores page is reached from SMS links that sign in with ?user=&code=.
    const authUser = $('meta[name="auth-user"]').attr('content');
    const authCode = $('meta[name="auth-code"]').attr('content');
    if (authUser && authCode) {
      data.user = authUser;
      data.code = authCode;
    }
    return data;
  }

  /**
   * Sends and closes: no confirmation. The tables pick up the new scores from the
   * UpdateSpotScores broadcast (below). A refused or failed send keeps it open, and so do
   * scores that don't match the recorded ones, to Cancel (keeping those) or Override them.
   */
  function send() {
    const command = scoreCommandFor(target?.prefix, $input.val());
    if (!command) return;
    $send.prop('disabled', true);
    $error.text('');
    $.ajax({ url: target.url, type: 'POST', data: requestData({ command: command }), dataType: 'json' })
      .done(function(resp) {
        if (resp?.score_conflict) {
          showConflict(resp.response_text || "These don't match the recorded scores.");
          return;
        }
        $modal.modal('hide');
      })
      .fail(function(xhr) {
        $error.text(xhr.responseJSON?.message || 'Could not send the score.');
        $send.prop('disabled', false);
      });
  }

  /** Same as replying O: products.score.override, which sits under the score link's URL. */
  function override() {
    $keep.add($override).prop('disabled', true);
    $error.text('');
    $.ajax({ url: target.url + '/override', type: 'POST', data: requestData({}), dataType: 'json' })
      .done(function(resp) {
        $entry.addClass('d-none');
        $conflict.addClass('d-none');
        $done.text(resp?.response_text || 'Override sent.').removeClass('d-none');
        $keep.add($override).addClass('d-none');
        $close.removeClass('d-none');
      })
      .fail(function(xhr) {
        $error.text(xhr.responseJSON?.message || 'Could not send the override.');
        $keep.add($override).prop('disabled', false);
      });
  }

  $input.on('input', function() {
    const command = scoreCommandFor(target?.prefix, $input.val());
    $preview.text(command ? 'Sends: ' + command : HINT);
    if (!$conflict.hasClass('d-none')) {
      showEntry();
    }
    $send.prop('disabled', !command);
  });
  $override.on('click', override);
  $input.on('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      send();
    }
  });
  $send.on('click', send);
  // Ready to type: focus once the modal has finished opening (Bootstrap takes focus while it animates).
  $modal.on('shown.bs.modal', function() {
    $input.trigger('focus');
  });

  // A score link carries everything the modal needs.
  function openFromLink(e) {
    e.preventDefault();
    e.stopPropagation();
    const $link = $(this);
    openModal({
      url: $link.data('url'),
      entityId: $link.data('entity_id'),
      name: $link.data('name'),
      prefix: $link.data('prefix'),
      label: $link.data('label'),
    });
  }
  // Tickets table: each round's score is a link. Bound on the table so stopping the event
  // here keeps the row from toggling its selection.
  $('.dt_ticket_table').on('click', 'a.js-score-link', openFromLink);
  // Seating chart (SpotsHtmlChartAction): replaced by AJAX, so delegated on the container.
  // Deeper than darby_events' '.spot' delegate, so stopping it here starts no spot swap.
  $('.spots').on('click', 'a.js-score-link', openFromLink);

  // Round Scores: the viewer's own row starts selected; on each selected row the viewer may
  // score, the round cells act as links.
  $('.js-round-scores').each(function() {
    const $table = $(this);
    function updateActiveRow() {
      $table.find('tbody tr').removeClass('score-row-active');
      $table.find('tbody tr.selected')
        .filter(function() { return !!$(this).data('can_score'); })
        .addClass('score-row-active');
    }
    $table.find('tbody tr[data-own="1"]').addClass('selected');
    updateActiveRow();
    // Fresh rows from an UpdateSpotScores refresh.
    $table.on('scores:refreshed', updateActiveRow);
    // After darby_back's own click handler has toggled the row.
    $table.on('click', 'tbody tr', function() { setTimeout(updateActiveRow, 0); });
    $table.on('select.dt deselect.dt draw.dt', function() { setTimeout(updateActiveRow, 0); });
    // A deeper delegate than the row's, so stopping it here keeps the row selected.
    $table.on('click', '.score-row-active .js-score-cell', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const $cell = $(this);
      const $row = $cell.closest('tr');
      openModal({
        url: $table.data('url'),
        entityId: $row.data('entity_id'),
        name: $row.data('name'),
        prefix: $cell.data('prefix'),
        label: $cell.data('label'),
      });
    });
  });
})();

/*** Live score tables: refresh rows in place on UpdateSpotScores instead of reloading ***/
(function() {
  if (!window.Echo) return;
  const timers = {};

  // One Pusher app serves every environment, so only act on this backend's broadcasts.
  function sameHost(appUrl) {
    try {
      return new URL(appUrl).hostname === window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  /**
   * Swap a table's rows for freshly rendered ones through DataTables, so its sort, search,
   * paging and column order stay as the user left them, and the same rows stay selected.
   */
  function refreshTable($table) {
    $.get($table.data('refresh_url')).done(function(html) {
      const $fresh = $(html).find('tbody tr');
      // Round Scores rows are a person each; ticket rows are a ticket each.
      const rowKey = (row) => $(row).data('entity_id') || row.id;
      if (!$.fn.dataTable.isDataTable($table[0])) {
        $table.find('tbody').empty().append($fresh);
        $table.trigger('scores:refreshed');
        return;
      }
      const dt = $table.DataTable();
      const keep = new Set(dt.rows('.selected').nodes().toArray().map(rowKey));
      dt.clear();
      dt.rows.add($fresh);
      dt.rows().nodes().toArray().forEach(function(row) {
        if (keep.has(rowKey(row))) row.classList.add('selected');
      });
      dt.draw(false);
      $table.trigger('scores:refreshed');
    });
  }

  // Scores arrive in bursts (both teams, then the round closing), so refresh once per burst.
  function refreshProductTables(productId) {
    clearTimeout(timers[productId]);
    timers[productId] = setTimeout(function() {
      $('table[data-refresh_url][data-product_id="' + productId + '"]').each(function() {
        refreshTable($(this));
      });
    }, 500);
  }

  window.Echo.channel('darby-events').listen('UpdateSpotScores', function(event) {
    if (sameHost(event.app_url)) refreshProductTables(event.product_id);
  });
})();

/*** Seating chart transfer icon: give the ticket to one of the event's participants or attendants ***/
(function() {
  const $modal = $('#transferModal');
  if (!$modal.length) return;
  const $search = $modal.find('.js-transfer-search');
  const $options = $modal.find('.js-transfer-options');
  const $status = $modal.find('.js-transfer-status');
  const $error = $modal.find('.js-transfer-error');
  // What the open modal is transferring: { transferUrl }
  let target = null;

  function authData() {
    const data = { _token: $('meta[name="csrf-token"]').attr('content') };
    // The scores page is reached from SMS links that sign in with ?user=&code=.
    const authUser = $('meta[name="auth-user"]').attr('content');
    const authCode = $('meta[name="auth-code"]').attr('content');
    if (authUser && authCode) {
      data.user = authUser;
      data.code = authCode;
    }
    return data;
  }

  function renderOptions(response) {
    $options.empty();
    (response.options || []).forEach(function(option) {
      const current = String(option.id) === String(response.current_entity_id);
      $('<button type="button" class="list-group-item list-group-item-action js-transfer-option"></button>')
        .text(option.name + (current ? ' (current)' : ''))
        .attr('data-entity_id', option.id)
        .attr('data-search', option.name.toLowerCase())
        .attr('data-current', current ? '1' : '0')
        .prop('disabled', current)
        .appendTo($options);
    });
    $status.text(response.options?.length ? '' : 'No participants or attendants yet.');
  }

  function open($link) {
    target = { transferUrl: $link.data('transfer_url') };
    $modal.find('.modal-title').text('Give ticket — ' + ($link.data('name') || ''));
    $search.val('');
    $options.empty();
    $error.text('');
    $status.text('Loading…');
    $modal.modal('show');
    $.get($link.data('options_url'), authData())
      .done(renderOptions)
      .fail(function(xhr) {
        $status.text('');
        $error.text(xhr.responseJSON?.message || 'Could not load the participants.');
      });
  }

  /** Transfers and closes: no confirmation. The chart refreshes itself. */
  function transfer() {
    const $option = $(this);
    $options.find('button').prop('disabled', true);
    $error.text('');
    const data = authData();
    data.entity_id = $option.data('entity_id');
    $.ajax({ url: target.transferUrl, type: 'POST', data: data, dataType: 'json' })
      .done(function() {
        $modal.modal('hide');
        $(document).trigger('spots:refresh');
      })
      .fail(function(xhr) {
        $error.text(xhr.responseJSON?.message || 'Could not transfer the ticket.');
        // Everyone but the current holder can be picked again.
        $options.find('button').prop('disabled', false);
        $options.find('[data-current="1"]').prop('disabled', true);
      });
  }

  $search.on('input', function() {
    const query = $search.val().trim().toLowerCase();
    $options.find('.js-transfer-option').each(function() {
      $(this).toggleClass('d-none', query !== '' && !String($(this).data('search')).includes(query));
    });
  });
  $options.on('click', '.js-transfer-option', transfer);
  // Ready to type a name once the modal has finished opening.
  $modal.on('shown.bs.modal', function() {
    $search.trigger('focus');
  });

  // Deeper than darby_events' '.spot' delegate, so stopping it here starts no spot swap.
  $('.spots').on('click', 'a.js-transfer-link', function(e) {
    e.preventDefault();
    e.stopPropagation();
    open($(this));
  });
})();
